const areaUnitTransformer = response => {
  return response.map(e => ({
    ...e,
    id: e.listingId,
    price: e.unitPrice,
    discount: e.maxDiscount,
    name: e.value,
    value: e?.listingId,
    label: e.value,
    FeatureCharges:
      e?.FeatureCharges?.map(item => ({
        ...item,
        key: item?.featureId,
        Feature: item?.Feature?.name,
        numberComponentRequired: true,
      })) || [],
  }))
}

export default areaUnitTransformer
